import { storeToRefs } from "pinia";

import { useGlobalStore } from "shared/stores/global";

const streemOnlyGuard = (to, from, next) => {
  const globalStore = useGlobalStore();
  const { isStreem } = storeToRefs(globalStore);

  if (isStreem.value) {
    next();
  } else {
    next("/");
  }
};

export default [
  {
    component: () => import("pages/social/GnipRuleList.vue"),
    meta: {
      title: "Twitter Capture Rules",
    },
    name: "twitter-capture-rules",
    path: "/social/twitter-capture-rules",
  },
  {
    component: () => import("pages/social/GnipRuleEdit.vue"),
    meta: {
      title: "New Twitter Capture Rule",
    },
    name: "twitter-capture-rule-new",
    path: "/social/twitter-capture-rules/new",
  },
  {
    component: () => import("pages/social/GnipRuleEdit.vue"),
    meta: {
      title: "Edit Twitter Capture Rule",
    },
    name: "twitter-capture-rule-edit",
    path: "/social/twitter-capture-rules/:gnipRuleId/edit",
    props: true,
  },
  {
    component: () => import("pages/social/SocialgistRuleList.vue"),
    meta: {
      title: "Socialgist Capture Rules",
    },
    name: "socialgist-capture-rules",
    path: "/social/socialgist-capture-rules",
  },
  {
    component: () => import("pages/social/SocialgistRuleEdit.vue"),
    meta: {
      title: "New Socialgist Capture Rule",
    },
    name: "socialgist-capture-rule-new",
    path: "/social/socialgist-capture-rules/new",
  },
  {
    component: () => import("pages/social/SocialgistRuleEdit.vue"),
    meta: {
      title: "Edit Socialgist Capture Rule",
    },
    name: "socialgist-capture-rule-edit",
    path: "/social/socialgist-capture-rules/:socialgistRuleId/edit",
    props: true,
  },
  {
    component: () => import("pages/social/SearchTweetsPage.vue"),
    meta: {
      title: "Search Tweets by URL",
    },
    name: "search-tweets",
    path: "/social/search-tweets",
  },
  {
    component: () => import("pages/social/TweetsPage.vue"),
    meta: {
      title: "Tweets",
    },
    name: "tweets",
    path: "/social/tweets",
  },
  {
    component: () => import("pages/social/FacebookPagesPage.vue"),
    meta: {
      title: "Facebook Pages",
    },
    name: "facebook-pages",
    path: "/social/facebook-pages",
  },
  {
    component: () => import("pages/social/AddEditFacebookPagesPage.vue"),
    meta: {
      title: "New Facebook Page",
    },
    name: "facebook-pages-new",
    path: "/social/facebook-pages/new",
  },
  {
    component: () => import("pages/social/AddEditFacebookPagesPage.vue"),
    meta: {
      title: "Edit Facebook Page",
    },
    name: "facebook-pages-edit",
    path: "/social/facebook-pages/:id",
    props: true,
  },
  {
    component: () => import("pages/FacebookPostList.vue"),
    meta: {
      title: "Facebook Posts",
    },
    name: "facebook-posts",
    path: "/social/facebook-posts",
  },
  {
    component: () => import("pages/FacebookPostEdit.vue"),
    meta: {
      title: "New Facebook Post",
    },
    name: "facebook-posts-new",
    path: "/social/facebook-posts/new",
    props: true,
  },
  {
    component: () => import("pages/FacebookPostEdit.vue"),
    meta: {
      title: "Edit Facebook Post",
    },
    name: "facebook-posts-edit",
    path: "/social/facebook-posts/:id",
    props: true,
  },
  {
    beforeEnter: streemOnlyGuard,
    component: () => import("pages/social/InstagramHandlesPage.vue"),
    meta: {
      title: "Instagram Handles",
    },
    name: "instagram-handles",
    path: "/social/instagram-handles",
  },
  {
    beforeEnter: streemOnlyGuard,
    component: () => import("pages/social/InstagramHandleEdit.vue"),
    meta: {
      title: "New Instagram Handle",
    },
    name: "instagram-handles-new",
    path: "/social/instagram-handles/new",
  },
  {
    beforeEnter: streemOnlyGuard,
    component: () => import("pages/social/InstagramHandleEdit.vue"),
    meta: {
      title: "Edit Instagram Handle",
    },
    name: "instagram-handles-edit",
    path: "/social/instagram-handles/:id",
    props: true,
  },
  {
    beforeEnter: streemOnlyGuard,
    component: () => import("pages/social/InstagramPostsPage.vue"),
    meta: {
      title: "Instagram Posts",
    },
    name: "instagram-posts",
    path: "/social/instagram-posts",
  },
  {
    beforeEnter: streemOnlyGuard,
    component: () => import("pages/social/InstagramPostEdit.vue"),
    meta: {
      title: "New Instagram Post",
    },
    name: "instagram-posts-new",
    path: "/social/instagram-posts/new",
  },
  {
    beforeEnter: streemOnlyGuard,
    component: () => import("pages/social/InstagramPostEdit.vue"),
    meta: {
      title: "Edit Instagram Post",
    },
    name: "instagram-posts-edit",
    path: "/social/instagram-posts/:id",
    props: true,
  },
  {
    component: () => import("pages/social/YoutubeChannelList.vue"),
    meta: {
      title: "Youtube Channels",
    },
    name: "youtube-channels",
    path: "/social/youtube-channels",
  },
  {
    component: () => import("pages/social/YoutubeChannelEdit.vue"),
    meta: {
      title: "New Youtube Channel",
    },
    name: "youtube-channels-new",
    path: "/social/youtube-channels/new",
  },
  {
    component: () => import("pages/social/YoutubeChannelEdit.vue"),
    meta: {
      title: "Edit Youtube Channel",
    },
    name: "youtube-channels-edit",
    path: "/social/youtube-channels/:id",
    props: true,
  },
  {
    component: () => import("pages/social/BlogsPage.vue"),
    meta: {
      title: "Blogs",
    },
    name: "blogs",
    path: "/social/blogs",
  },
  {
    component: () => import("pages/social/BlogEdit.vue"),
    meta: {
      title: "New Blog",
    },
    name: "blogs-new",
    path: "/social/blogs/new",
  },
  {
    component: () => import("pages/social/BlogEdit.vue"),
    meta: {
      title: "Edit Blog",
    },
    name: "blogs-edit",
    path: "/social/blogs/:id",
    props: true,
  },
  {
    component: () => import("pages/social/BlogPostsPage.vue"),
    meta: {
      title: "Blog Posts",
    },
    name: "blog-posts",
    path: "/social/blog-posts",
  },
  {
    component: () => import("pages/social/BlogPostEdit.vue"),
    meta: {
      title: "New Blog Post",
    },
    name: "blog-posts-new",
    path: "/social/blog-posts/new",
  },
  {
    component: () => import("pages/social/BlogPostEdit.vue"),
    meta: {
      title: "Edit Blog Post",
    },
    name: "blog-posts-edit",
    path: "/social/blog-post/:id",
    props: true,
  },
  {
    component: () => import("pages/social/ForumsPage.vue"),
    meta: {
      title: "Forums",
    },
    name: "forums",
    path: "/social/forums",
  },
  {
    component: () => import("pages/social/ForumEdit.vue"),
    meta: {
      title: "New Forum",
    },
    name: "forums-new",
    path: "/social/forums/new",
  },
  {
    component: () => import("pages/social/ForumEdit.vue"),
    meta: {
      title: "Edit Forum",
    },
    name: "forums-edit",
    path: "/social/forums/:id",
    props: true,
  },
  {
    component: () => import("pages/social/BlueskyPostsPage.vue"),
    meta: {
      title: "Bluesky Posts",
    },
    name: "bluesky-posts",
    path: "/social/bluesky-posts",
  },
];
